import clx from 'classnames';
import { AlertTriangle, CalendarDays, ChevronRight, Rocket, Settings, Users } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import LinearProgress from '../../../Common/LinearProgress';
import { ReactComponent as InstagramIcon } from '../../../../assets/svg/badgets/instagram.svg';
import styles from './SchedulerWorker.module.scss';

const WorkerChairMenu = ({
  hasOverlappingBookings,
  modalData = {},
  tasks = [],
  queueCount = 0,
  canManageChair = false,
  manageLabel,
  onShare,
  onQueue,
  onManage,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {hasOverlappingBookings ? (
        <div className={styles.overlap_banner}>
          <AlertTriangle size={16} strokeWidth={2.4} />
          <span>
            <Trans
              i18nKey="scheduler.schedulerWorker.overlap.banner"
              components={{ 1: <br /> }}
            />
          </span>
        </div>
      ) : null}
      <div
        className={clx(styles.dropdown_stats, {
          [styles.dropdown_stats_soldout]: modalData.soldOut,
        })}
      >
        <div className={styles.dropdown_stats_count}>
          <CalendarDays size={16} strokeWidth={2.2} />
          <span className={styles.text_strong}>{tasks.length ?? 0}</span>
          <span className={styles.text}>
            {tasks.length != 1
              ? t('scheduler.schedulerWorker.dropdown.bookings')
              : t('scheduler.schedulerWorker.dropdown.booking')}
          </span>
        </div>
        <div className={styles.linear_progress_box}>
          <LinearProgress
            percent={modalData.soldOut ? 100 : modalData.percent}
            color={modalData.soldOut ? '#FCB734' : '#858AF9'}
            compact
            trackColor={modalData.soldOut ? 'rgba(255, 255, 255, 0.18)' : undefined}
          />
          <div
            className={clx(styles.linear_progress_box_text, {
              [styles.linear_progress_box_text_full]: modalData.percent >= 100,
              [styles.linear_progress_box_text_soldout]: modalData.soldOut,
            })}
          >
            {modalData.soldOut ? <Rocket size={12} strokeWidth={2.4} /> : null}
            {modalData.label}
          </div>
        </div>
        {!modalData.closed ? (
          <button type="button" className={styles.dropdown_share} onClick={onShare}>
            <InstagramIcon className={styles.dropdown_share_icon} />
            <span>{t('scheduler.schedulerWorker.dropdown.shareInstagram')}</span>
          </button>
        ) : null}
      </div>
      <div className={styles.dropdown_actions}>
        <button type="button" className={styles.dropdown_action} onClick={onQueue}>
          <Users size={16} strokeWidth={2.2} />
          <span>{t('scheduler.schedulerWorker.dropdown.viewQueue')}</span>
          {queueCount > 0 ? (
            <span className={styles.dropdown_action_count}>{queueCount}</span>
          ) : null}
          <ChevronRight size={16} strokeWidth={2.2} />
        </button>
        {canManageChair ? (
          <button type="button" className={styles.dropdown_action} onClick={onManage}>
            <Settings size={16} strokeWidth={2.2} />
            <span>
              {manageLabel || t('scheduler.schedulerWorker.dropdown.manageChair')}
            </span>
            <ChevronRight size={16} strokeWidth={2.2} />
          </button>
        ) : null}
      </div>
    </>
  );
};

export default WorkerChairMenu;
